<template>
  <div>
    <el-form :model="form" ref="form" :rules="rules" label-position="top">
      <div
        v-if="
          actionType === patientQuickActions.assignPod || actionType === 'ALL'
        "
      >
        <el-form-item prop="AllocatedPod">
          <span slot="label">
            {{ $t('text.pod_serial_number') }}
            <el-tooltip placement="top">
              <img
                src="@/assets/image/how-to-find-device-info/pod-number.png"
                slot="content"
                class="w-200"
              />
              <i class="el-icon-question"></i>
            </el-tooltip>
          </span>
          <SerialNumber
            @podSerialNumberChange="podSerialNumberChange"
            :value="form.AllocatedPod"
            v-if="podSerialNumberIsManually"
          />
          <el-select
            v-else
            v-model="form.AllocatedPod"
            filterable
            :placeholder="$t('text.select')"
            class="wp-100"
            :loading="fetchPodOptionsLoading"
            :no-data-text="$t('text.no_pods_text')"
          >
            <el-option
              v-for="item in podSerialNumberOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <!-- <div class="text-right" style="margin-top: -15px">
          <span
            @click="podSerialNumberIsManually = !podSerialNumberIsManually"
            class="toggle-mode"
          >
            {{
              podSerialNumberIsManually
                ? $t('text.registered_pods')
                : $t('text.enter_manually')
            }}
          </span>
        </div> -->
      </div>
      <div v-if="actionType !== patientQuickActions.assignPod">
        <el-divider
          v-if="actionType !== patientQuickActions.assignNode"
        ></el-divider>
        <div v-if="actionType !== patientQuickActions.assignNode">
          <span class="toggle-mode" @click="toogleShowNodeMac()">{{
            showNodeMacAddress
              ? $t('text.remove_node_mac_address')
              : $t('text.link_a_node_mac_address')
          }}</span>
        </div>
        <el-collapse-transition>
          <div class="mt-15" v-show="showNodeMacAddress">
            <el-form-item prop="NodeMacAddress">
              <span slot="label">
                {{ $t('text.node_mac_address') }}
                <el-tooltip placement="top">
                  <img
                    src="@/assets/image/how-to-find-device-info/node-mac-address.png"
                    slot="content"
                    class="w-200"
                  />
                  <i class="el-icon-question"></i>
                </el-tooltip>
              </span>
              <NodeMacAddress
                :value="form.NodeMacAddress"
                @nodeMacAddressChange="nodeMacAddressChange"
                v-if="nodeMacAddressIsManually"
              />
              <el-select
                v-else
                v-model="form.NodeMacAddress"
                filterable
                :placeholder="$t('text.select')"
                class="wp-100"
                :loading="fetchNodeOptionsLoading"
                :no-data-text="$t('text.no_nodes_text')"
              >
                <el-option
                  v-for="item in nodeMacAddressOptions"
                  :key="item"
                  :label="item"
                  :value="item"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <!-- <div class="text-right" style="margin-top: -15px">
              <span
                @click="nodeMacAddressIsManually = !nodeMacAddressIsManually"
                class="toggle-mode"
              >
                {{
                  nodeMacAddressIsManually
                    ? $t('text.registered_nodes')
                    : $t('text.enter_manually')
                }}
              </span>
            </div> -->
          </div>
        </el-collapse-transition>
      </div>
    </el-form>
  </div>
</template>

<script>
import { patientQuickActions } from '@/const'
import SerialNumber from '@/components/manage/patients/SerialNumber.vue'
import NodeMacAddress from '@/components/manage/patients/NodeMacAddress.vue'
import ApiService from '@/services/ApiService.js'
import swal from 'sweetalert'
import { podSerialNumberDisplayPrefix } from '@/const'
export default {
  data() {
    return {
      patientQuickActions,
      loading: false,
      podSerialNumberOptions: [],
      fetchPodOptionsLoading: false,
      podSerialNumberIsManually: false,
      nodeMacAddressOptions: [],
      fetchNodeOptionsLoading: false,
      nodeMacAddressIsManually: false,
      form: {
        PatientId: '',
        NodeMacAddress: '',
        AllocatedPod: ''
      },
      rules: this.initRules(),
      showNodeMacAddress: false
    }
  },
  props: {
    actionType: {
      type: String,
      default: 'ALL'
    }
  },
  components: {
    SerialNumber,
    NodeMacAddress
  },
  watch: {
    podSerialNumberIsManually() {
      this.form.AllocatedPod = ''
    },
    nodeMacAddressIsManually() {
      this.form.NodeMacAddress = ''
    },
    'form.NodeMacAddress'() {
      if (
        this.form.NodeMacAddress ||
        this.actionType === this.patientQuickActions.assignNode
      ) {
        this.showNodeMacAddress = true
      }
    },
    actionType() {
      if (
        this.form.NodeMacAddress ||
        this.actionType === this.patientQuickActions.assignNode
      ) {
        this.showNodeMacAddress = true
      }
    }
  },
  mounted() {
    this.getPodOptions()
    this.getNodeOptions()
  },
  methods: {
    initRules() {
      let checkMacAddress = (rule, value, callback) => {
        let macAddressRule = /[A-F0-9:]/
        if (value && (!macAddressRule.test(value) || value.length !== 17)) {
          callback(new Error(this.$t('text.mac_address_format_warning')))
        } else {
          callback()
        }
      }
      let checkSerialNumber = (rule, value, callback) => {
        let serialNumberRule = /[A-F0-9]/
        if (value && (!serialNumberRule.test(value) || value.length !== 4)) {
          callback(
            new Error(this.$t('text.pod_serial_number_format_incorrect'))
          )
        } else {
          callback()
        }
      }
      let rules = {
        AllocatedPod: [
          {
            required: true,
            message: this.$t('text.please_enter_pod_serial_number'),
            trigger: ['change', 'blur']
          },
          { validator: checkSerialNumber, trigger: 'blur' }
        ],
        NodeMacAddress: [
          { validator: checkMacAddress, trigger: ['change', 'blur'] }
        ]
      }
      if (this.actionType === patientQuickActions.assignPod) {
        delete rules.NodeMacAddress
      }
      if (this.actionType === patientQuickActions.assignNode) {
        delete rules.AllocatedPod
      }
      return rules
    },
    getPodOptions() {
      if (!this.$store.getters[`user/selecteOrganisationId`]) return false
      this.fetchPodOptionsLoading = true
      ApiService.GetSitePods(
        this.$store.getters[`user/selecteOrganisationId`]
      ).then(response => {
        this.fetchPodOptionsLoading = false
        if (response.data.success) {
          this.podSerialNumberOptions = response.data.data.map(item => {
            return {
              ...item,
              value: item.MacAddress.substring(item.MacAddress.length - 4),
              label:
                podSerialNumberDisplayPrefix +
                item.MacAddress.substring(item.MacAddress.length - 4)
            }
          })
        } else {
          this.fetchPodOptionsLoading = false
          swal({
            icon: 'error',
            timer: 2000,
            title: this.$t('text.failed'),
            text: response.data.msg
          })
        }
      })
    },
    getNodeOptions() {
      if (!this.$store.getters[`user/selecteOrganisationId`]) return false
      this.fetchPodOptionsLoading = true
      ApiService.getSiteNodes(
        this.$store.getters[`user/selecteOrganisationId`]
      ).then(response => {
        this.fetchNodeOptionsLoading = false
        if (response.data.success) {
          this.nodeMacAddressOptions = response.data.data.map(item => {
            return item.MacAddress
          })
        } else {
          this.fetchPodOptionsLoading = false
          swal({
            icon: 'error',
            timer: 2000,
            title: this.$t('text.failed'),
            text: response.data.msg
          })
        }
      })
    },
    podSerialNumberChange(data) {
      this.form.AllocatedPod = data
        .filter(item => {
          return !item.disabled
        })
        .map(item => {
          return item.character
        })
        .join('')
    },
    nodeMacAddressChange(data) {
      // Assemble strings into MAC address format
      this.form.NodeMacAddress = data
        .map((item, index) => {
          return (index + 1) % 2 === 0 && index !== data.length - 1
            ? item.character + ':'
            : item.character
        })
        .join('')
    },
    toogleShowNodeMac() {
      this.showNodeMacAddress = !this.showNodeMacAddress
      if (!this.showNodeMacAddress) {
        this.form.NodeMacAddress = ''
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.toggle-mode {
  display: inline-block;
  cursor: pointer;
  color: #409eff;
  text-decoration: underline;
  margin-top: -10px !important;
}
</style>
